import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, reset } from "redux-form";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  Form,
  FormGroup,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Label,
} from "reactstrap";
import {
  getEmployeesByStore,
  resetEmployeesByStore,
} from "../../../../store/employee/actions";
import {
  getRewards,
  claimReward,
  setCurrentGift,
  resetRewards,
  getCurrentGift,
  getServices,
} from "../../../../store/reward/actions";
import { toast } from "react-toastify";
import { DataTable, TableRowField, MainLoader } from "../../../../components";
import { layout, roles } from "../../../../common/constants";
import { selectUserRole } from "../../../../store/user/selector";
import MediaQuery from "react-responsive";
import { validate } from "./_validate";

function RewardList(props) {
  const [page, setPage] = useState(1),
    [rewardSelected, setRewardSelected] = useState(0),
    [modalOpen, setModalOpen] = useState(false),
    [modalGiftOpen, setModalGiftOpen] = useState(false),
    [filter, setFilter] = useState("");

  useEffect(() => {
    _performGetRewards(true);
    props.getCurrentGift();
    return () => {
      props.resetRewards();
      props.resetEmployeesByStore();
    };
  }, []);

  function _performGetRewards(reset = false) {
    props.getRewards({ page, filter, reset });
  }
  function _performGetEmployeesByStore(store_id, reset = false) {
    props.getEmployeesByStore({ store_id, reset });
  }

  async function _handlePageChange(page) {
    await setPage(page);
    _performGetRewards();
  }
  function _performClaimReward(values) {
    if (!values.employee_id) return;
    props.claimReward(rewardSelected, values.employee_id, () => {
      _performGetRewards();
      toast.success("Recompensa canjeada");
      props.resetForm("ClaimReward");
      setModalOpen(false);
    });
  }
  function _performSetCurrentGift(values) {
    if (!values.service_id) return;
    props.setCurrentGift(values.service_id, () => {
      props.getCurrentGift();
      toast.success("Servicio como regalo actualizado");
      props.resetForm("ClaimReward");
      setModalGiftOpen(false);
    });
  }

  async function _filterCategories() {
    await setPage(1);
    _performGetRewards();
  }

  function _handleInputFilterChange(e) {
    if (e.key === "Enter") {
      _filterCategories();
    }
  }

  function _optionsFormatterColumn(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              _performGetEmployeesByStore(row.store_id);
              setModalOpen(true);
              setRewardSelected(row.id);
            }}
            disabled={row.claimed ? true : false}
          >
            <i className="fa fa-eye mr-1" />
            Seleccione el Empleado
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  function _renderEmployeesByStore(field) {
    const {
        meta: { touched, error },
      } = field,
      hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="3">
          <Label htmlFor="select">Empleado:</Label>
        </Col>
        <Col md="9">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {props.employeesByStore.map((employee) => (
              <option key={employee.id} value={employee.id}>
                {employee.name + " " + employee.lastname}
              </option>
            ))}
          </Input>
        </Col>
      </FormGroup>
    );
  }

  function _renderCurrentGiftModal(field) {
    const {
        meta: { touched, error },
      } = field,
      hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="3">
          <Label htmlFor="select">Servicio:</Label>
        </Col>
        <Col md="9">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {props.services.map((service) => (
              <option key={service.id} value={service.id}>
                {service.name}
              </option>
            ))}
          </Input>
        </Col>
      </FormGroup>
    );
  }
  function _renderDataTable(columns) {
    return (
      <DataTable
        data={props.rewards}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={props.total}
        sizePerPage={props.pageSize}
        loading={props.loading}
        onPageChange={_handlePageChange}
      />
    );
  }

  const columnOption = {
      dataField: "",
      text: "",
      formatter: _optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    },
    columnsXS = [
      {
        dataField: "xs",
        text: "Recompensa",
        formatter: (cell, row) => (
          <div>
            <TableRowField
              label="Código:"
              value={row.code || "Oculto por seguridad"}
            />
            <TableRowField
              label="Reclamado:"
              value={row.claimed ? "SI" : "NO"}
            />
            <TableRowField label="Puntos:" value={row.points} />
            <TableRowField
              label="Cliente:"
              value={row.Customer.name + " " + row.Customer.lastname}
            />
            {row.Service && (
              <TableRowField label="Servicio:" value={row.Service.name} />
            )}
            {row.Store && (
              <TableRowField label="Tienda:" value={row.Store.name} />
            )}
            <TableRowField label="Tipo:" value={row.Reward_type.name} />
          </div>
        ),
      },
      columnOption,
    ],
    columnsSM = [
      {
        dataField: "xs",
        text: "Recompensa",
        formatter: (cell, row) => (
          <div>
            <TableRowField
              label="Código:"
              value={row.code || "Oculto por seguridad"}
            />
            <TableRowField
              label="Reclamado:"
              value={row.claimed ? "SI" : "NO"}
            />
            <TableRowField label="Puntos:" value={row.points} />
            <TableRowField
              label="Cliente:"
              value={row.Customer.name + " " + row.Customer.lastname}
            />
            {row.Service && (
              <TableRowField label="Servicio:" value={row.Service.name} />
            )}
            {row.Store && (
              <TableRowField label="Tienda:" value={row.Store.name} />
            )}
            <TableRowField label="Tipo:" value={row.Reward_type.name} />
          </div>
        ),
      },
      columnOption,
    ],
    columns = [
      {
        text: "Código",
        formatter: (cell, row) => row.code || "Oculto por seguridad",
      },
      {
        text: "Reclamado",
        formatter: (cell, row) => (row.claimed ? "SI" : "NO"),
      },
      {
        text: "Puntos",
        dataField: "points",
      },
      {
        text: "Cliente",
        formatter: (cell, row) =>
          row.Customer.name + " " + row.Customer.lastname,
      },
      {
        text: "Servicio",
        formatter: (cell, row) => (row.Service ? row.Service.name : "N/A"),
      },
      {
        text: "Tienda",
        formatter: (cell, row) => (row.Store ? row.Store.name : "N/A"),
      },
      {
        text: "Tipo",
        dataField: "Reward_type.name",
      },
      columnOption,
    ];

  return props.loading ? (
    <MainLoader />
  ) : (
    <div className="animated">
      <Card>
        <CardHeader>
          <i className="icon-share-alt"></i>
          Recompensas
        </CardHeader>
        <CardBody>
          <MediaQuery minDeviceWidth={600}>
            {(matches) => {
              return matches ? (
                <Row className="mb-2">
                  <Col sm="8">
                    <InputGroup>
                      <Input
                        type="text"
                        id="input1-group2"
                        name="input1-group2"
                        placeholder="Buscar"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        onKeyPress={_handleInputFilterChange}
                      />
                      <div className="input-group-prepend">
                        <Button
                          type="button"
                          color="primary"
                          onClick={_filterCategories}
                        >
                          <i className="fa fa-search" />
                        </Button>
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
              ) : (
                <Row className="mb-2">
                  <Col md="10">
                    <InputGroup>
                      <Input
                        type="text"
                        id="input1-group2"
                        name="input1-group2"
                        placeholder="Buscar"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        onKeyPress={handleInputFilterChange}
                      />
                      <div className="input-group-prepend">
                        <Button
                          type="button"
                          color="primary"
                          onClick={_filterCategories}
                        >
                          <i className="fa fa-search" />
                        </Button>
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
              );
            }}
          </MediaQuery>
          {props.role == roles.SUPER_ADMIN && (
            <React.Fragment>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                Regalo activo para aplicación Móvil:{" "}
                {props.gift ? props.gift.name : "Aún no está definido"}
              </div>
              <Button
                type="button"
                color="primary"
                onClick={() => {
                  props.getServices();
                  setModalGiftOpen(true);
                }}
              >
                Cambiar Regalo
              </Button>
            </React.Fragment>
          )}
          <hr className="my-4" />
          <Row>
            <Col>
              <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                {_renderDataTable(columnsXS)}
              </MediaQuery>
              <MediaQuery
                minWidth={layout.SM_MIN_WIDTH}
                maxWidth={layout.MD_MAX_WIDTH}
              >
                {_renderDataTable(columnsSM)}
              </MediaQuery>
              <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                {_renderDataTable(columns)}
              </MediaQuery>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Modal isOpen={modalOpen}>
        <Form onSubmit={props.handleSubmit(_performClaimReward)}>
          <ModalHeader>Selecciona el empleado a realizar la tarea</ModalHeader>
          <ModalBody>
            <Field name="employee_id" component={_renderEmployeesByStore} />
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col className="mt-3">
                <Button
                  type="submit"
                  disabled={props.claimedLoading}
                  color="primary"
                  className="mr-2"
                >
                  <i className="fa fa-save mr-1" />
                  Guardar
                </Button>
                <Button color="secondary" onClick={() => setModalOpen(false)}>
                  <i className="fa fa-chevron-left mr-1" />
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal isOpen={modalGiftOpen}>
        <Form onSubmit={props.handleSubmit(_performSetCurrentGift)}>
          <ModalHeader>
            Seleccione el servicio que servirá como regalo
          </ModalHeader>
          <ModalBody>
            <Field name="service_id" component={_renderCurrentGiftModal} />
          </ModalBody>
          <Label style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            Si el servicio no se encuentra listado, por favor edita el servicio
            y completa el campo "Puntos Aplicación Móvil"
          </Label>
          <ModalFooter>
            <Row>
              <Col className="mt-3">
                <Button
                  type="submit"
                  disabled={props.setCurrentGiftLoading}
                  color="primary"
                  className="mr-2"
                >
                  <i className="fa fa-save mr-1" />
                  Guardar
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setModalGiftOpen(false)}
                >
                  <i className="fa fa-chevron-left mr-1" />
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    services: state.reward.serviceList.services,
    rewards: state.reward.rewardList.rewards,
    gift: state.reward.currentGift.gift,
    employeesByStore: state.employee.employeeByStoreList.employees,
    error: state.reward.rewardList.error,
    loading: state.reward.rewardList.loading,
    pageSize: state.reward.rewardList.pageSize,
    total: state.reward.rewardList.total,
    claimed: state.reward.rewardClaimed,
    claimedLoading: state.reward.rewardClaimed.loading,
    claimedError: state.reward.rewardClaimed.error,
    setCurrentGiftLoading: state.reward.setCurrentGift.loading,
    setCurrentGiftError: state.reward.setCurrentGift.error,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRewards,
      getServices,
      getEmployeesByStore,
      getCurrentGift,
      claimReward,
      setCurrentGift,
      resetRewards,
      resetEmployeesByStore,
      resetForm: reset,
    },
    dispatch
  );
}

export default reduxForm({
  form: "ClaimReward",
  touchOnBlur: false,
  // enableReinitialize: true,
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(RewardList));



// WEBPACK FOOTER //
// ./src/scenes/Administration/Reward/RewardList/RewardList.js